import React from "react";
import { CopyToSuppliersModal } from "../../../CopyToSuppliersModal";
import { useClarificationsRegisterContext } from "../ClarificationsRegisterContext";

export const CopyToSuppliersModalWrapper: React.FC = () => {
  const { data, modals, props } = useClarificationsRegisterContext();
  const { suppliers } = data;
  const { copyingClarification, setCopyingClarification, isCopying, handleCopyToSuppliers } = modals;
  const { allSuppliers } = props;

  return (
    <CopyToSuppliersModal
      isOpen={copyingClarification !== null}
      clarification={copyingClarification}
      suppliers={allSuppliers ?? suppliers}
      isLoading={isCopying}
      onClose={() => setCopyingClarification(null)}
      onConfirm={handleCopyToSuppliers}
    />
  );
};
